module.exports = __webpack_public_path__ + "img/n1.2ec2ac02.webp";